interface ButtonProps {
  title: string
  onClick?: () => void
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
  size?: 'sm' | 'md' | 'lg'
  icon?: string
  iconAlt?: string
  iconWithBackground?: boolean
  className?: string
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
}

function Button({ 
  title, 
  onClick, 
  variant = 'primary', 
  size = 'md', 
  icon, 
  iconAlt = 'Icon',
  iconWithBackground = false,
  className = '',
  disabled = false,
  type = 'button'
}: ButtonProps) {

  // Add cursor-pointer by default, unless disabled
  const baseClasses = "font-semibold transition-all duration-300 flex items-center gap-2 sm:gap-3 rounded-full cursor-pointer"
  
  const variantClasses = {
    primary: "bg-white/20 hover:bg-white/30 text-white",
    secondary: "bg-[#F55109] hover:bg-[#F55109]/80 text-white",
    outline: "border-2 border-white text-white hover:bg-white hover:text-black",
    ghost: "text-white hover:text-gray-300"
  }
  

  const sizeClasses = {
    sm: "px-2 py-2 text-xs sm:px-4 sm:py-3 sm:text-sm",
    md: "px-3 py-3 text-sm sm:px-6 sm:py-4 sm:text-base",
    lg: "px-4 py-3 text-base sm:px-8 sm:py-5 sm:text-lg"
  }
  
  // If disabled, override cursor-pointer with cursor-not-allowed
  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : ""
  
  const buttonClasses = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
    >
      <span className="leading-none">{title}</span>
      {icon && (
        iconWithBackground ? (
          <div className="flex items-center justify-center w-8 h-8 sm:w-12 sm:h-12 bg-[#F55109] rounded-full transition-transform group-hover:translate-x-1">
            <img
              src={icon}
              alt={iconAlt}
              className="w-4 h-4 sm:w-6 sm:h-6"
            />
          </div>
        ) : (
          <img
            src={icon}
            alt={iconAlt}
            className="w-4 h-4 sm:w-6 sm:h-6 transition-transform group-hover:translate-x-1"
          />
        )
      )}
    </button>
  )
}

export default Button